import React from "react";
import { secureStorage } from "../../../../utils/secureStorage";
import { useNavigate } from "react-router";
import { useAuth } from "../../../../utils/useAuth";

const BookTour = ({ TourData }) => {
  const navigate = useNavigate();
  const { user, isLoggedIn } = useAuth();
  const handleContinue = () => {
    if (!isLoggedIn) {
      navigate("/authentication/signin");
    } else {
      secureStorage.setItem("BookTour", JSON.stringify(TourData));
      navigate("/booking/tour");
    }
  };
  return (
    <div className="w-full border">
      <div className="p-3 bg-[#d8ecff]">
        <p className="font-bold"> Tour Booking Breakdown</p>
      </div>
      {TourData?.data ? (
        <div className="space-y-3 p-4">
          <div className="flex justify-between items-center">
            <p className="text-sm font-bold text-black/80">Regular Price:</p>
            <p className="text-md font-bold text-black/80">
              {TourData.data.price.toFixed(0)} BDT
            </p>
          </div>
          <div className="flex justify-between items-center">
            <p className="text-sm font-bold text-black/80">Discount:</p>
            <p className="text-md font-bold text-black/80">
              {TourData.data.discount}%
            </p>
          </div>
          <div className="flex justify-between items-center">
            <p className="text-sm font-bold text-black/80">Total Price:</p>
            <p className="text-md font-bold text-black/80">
              {(
                TourData.data.price -
                (TourData.data.price * TourData.data.discount) / 100
              ).toFixed(0)}{" "}
              BDT
            </p>
          </div>
          <div>
            <p className="text-xs text-black text-center">
              * This price is for per person.
            </p>
          </div>
        </div>
      ) : (
        <div className="flex justify-center bg-[#d8ecff3f] items-center py-28">
          <p className="text-center text-sm text-black/50">
            Data is not available!
          </p>
        </div>
      )}

      <div>
        <button
          onClick={handleContinue}
          className={`px-4 py-1  text-nowrap bg-[#0e1435]  text-white w-full scale-100 hover:scale-105 transition-all duration-300 cursor-pointer rounded-b-lg`}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default BookTour;
